<template>
<div>
	 <!-- <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div> -->
  <CCard>
    <CCardHeader>
      <slot name="header" class="d-flex align-center justify-space">
        <span><CIcon name="cil-grid" class="mr-2"/> {{caption}}</span>
		<CButton color="primary" class="px-4" @click="add()" :class="addcondition ? '':'hidden'">Add User</CButton>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="small ? 10 : 5"
        :dark="dark"
        pagination
		tableFilter
		sorter		
		itemsPerPageSelect
      >
        <template #status="{item}">         
		  <td>
			<CBadge :color="getBadge(item.status)" v-on:click="change_status(item.UserID);"			:id="'status_'+item.UserID">{{item.status}}</CBadge>
          </td>
        </template>
		<template #action="{item}">         
		  <td>
            <CButton color="primary" class="mr-2" :class="editcondition ? '':'hidden'" :color="getEdit(item.action)" @click="edit(item.UserID)">Edit</CButton>
			<CButton :color="getDelete(item.action)" :class="deletecondition ? '':'hidden'" @click="deletepop(item.UserID)">Delete</CButton>			
          </td>
        </template>
      </CDataTable>
	  <CModal
      :show.sync="myModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Delete"
      size="sm"
      color="dark"
    >
      Are you wan't to delete this?
      <template #header>
        <h6 class="modal-title">Delete</h6>
        <CButtonClose @click="myModal = false" class="text-white"/>
      </template>
      <template #footer>
         <CButton @click="myModal = false" color="danger">Cancel</CButton>
         <CButton @click="deleteRow" id="del" color="success">Delete</CButton>
      </template>
    </CModal>  
	 
    </CCardBody>
  </CCard>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: 'Manage_user',
  data () {
    return {
	  isLoading: false,
      myModal: false,
	  addcondition:"",
	  editcondition:"",
	  deletecondition:"",
	}
  },
  props: {
    items: Array,
    fields: {
      type: Array,
      default () {
        return ['UserID','Username', 'Email', 'Mobile', 'status','action']
      }
    },
    caption: {
      type: String,
      default: 'Manage_user'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
	dark: Boolean,
	responsive: Boolean
  },
  mounted () {
	var app_roleId=JSON.parse(localStorage.getItem("app_roleId"));
	if(app_roleId=='1'){		
		this.addcondition="1";
		this.editcondition='1';
		this.deletecondition='1';
	}else{
		var userRules=JSON.parse(localStorage.getItem("RoleWiseModules"));
		var modulefind = userRules.find(function(jsonitem, f){
			if(jsonitem.Slug=='add_user'){
				this.addcondition="1";
			}
			if(jsonitem.Slug=='edit_user'){
				this.editcondition="1";
			}
			if(jsonitem.Slug=='delete_user'){
				this.deletecondition="1";
			}
		});	
	}
  },
  methods: {
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'secondary'
          : status === 'Pending' ? 'warning'
            : status === 'Banned' ? 'danger' : 'primary'
    },
	getEdit (color) {
      return 'primary';
    },
	getDelete(color){
		return 'danger';
	},
	edit(id){				
		localStorage.setItem("edit_id",id); 		
		this.$router.push({path:'edit_users'})
	},
	change_status(id){		
		var IsActive=$('#status_'+id).html();
		if(IsActive=='Active'){
			IsActive="In-Active"
		}else{
			IsActive="Active"
		}
		var Session_User_Id=JSON.parse(localStorage.getItem("User_Id"));
		var token=localStorage.getItem("auth");	
		var requestInfo = {
			User_Id: id,
			Status:IsActive,
			Token:token,
			Session_User_Id:Session_User_Id,
		};		
		var data = JSON.stringify(requestInfo);				
		var self = this;
		var config = {
		  method: 'post',
		  url: apiURL+'ManageUsers/UpdateUserStatus',
		  headers: { 
			'Content-Type': 'application/json'
		  },
		  data : data
		};
		this.isLoading = true;
		axios(config)
		.then((result) => {	
			this.isLoading = false;		
			if(result.data.status_code==200){
				$('#status_'+id).html(IsActive);				
				this.$swal.fire({
					title: "Status", 
					text: "Status Change Successfully..", 
					type: "success"					  
				}).then(function(){ 
						//location.reload();
				   }
				);				
			}else{
				this.$swal.fire({
				  icon: 'error',
				  title: 'Oops...',
				  text: result.data.message		 
				})				
			}
		  
		})
		.catch((error) => {
			this.isLoading = false;				
			this.$swal.fire({
			  icon: 'error',
			  title: 'Oops...',
			  text: 'Something went wrong!'		 
			})
		});
	},deletepop(id){
		this.$swal.fire({
		  title: 'Are you sure?',
		  text: "You won't delete this!",
		  icon: 'warning',
		  showCancelButton: true,
		  confirmButtonColor: '#3085d6',
		  cancelButtonColor: '#d33',
		  confirmButtonText: 'Yes, delete it!'
		}).then((result) => {
		  if (result.isConfirmed) {
			var Session_User_Id=JSON.parse(localStorage.getItem("User_Id"));
			var token=localStorage.getItem("auth");	
			var requestInfo = {
				User_Id: id,		
				Token:token,
				Session_User_Id:Session_User_Id,
			};
			//console.log(requestInfo);
			var data = JSON.stringify(requestInfo);				
			var self = this;
			var config = {
			  method: 'post',
			  url: apiURL+'ManageUsers/DeleteUser',
			  headers: { 
				'Content-Type': 'application/json'
			  },
			  data : data
			};
			this.isLoading = true;
			axios(config)
			.then((result) => {	
				this.isLoading = false;		
				if(result.data.status_code==200){
					//var obj=result.data.response;
					//console.log(obj[0]);
					//alert(result.data.message);					
					this.$swal.fire({
						title: "Deleted", 
						text: "Your record has been deleted.", 
						type: "success"					  
					}).then(function(){ 
					   location.reload();
					   }
					);
					//$('#reponse_error').html(result.data.message);
				}else{
					this.$swal.fire({
					  icon: 'error',
					  title: 'Oops...',
					  text: result.data.message		 
					})
					//$('#reponse_error').html(result.data.message);
				}
			  
			})
			.catch((error) => {
				this.isLoading = false;	
				//var errorObject=JSON.stringify(error.response.data.errors);			
				//console.log(errorObject);
				this.$swal.fire({
				  icon: 'error',
				  title: 'Oops...',
				  text: 'Something went wrong!'		 
				})
			});
			
		  }
		})
		//$("#del").attr("rowData",id);
		//this.myModal= true;
		//alert('call'+id);
	},
	add(){
		//console.log('add');
		this.$router.push({path:'add_users'})
	},
	deleteRow(){
		var id=$("#del").attr("rowData");
		//console.log('delete '+id);
		//alert('delete');
		this.myModal= false;
		//this.$router.push({name:'Add_roles'})
		var Session_User_Id=JSON.parse(localStorage.getItem("User_Id"));
		var token=localStorage.getItem("auth");	
		var requestInfo = {
		User_Id: id,		
		Token:token,
		Session_User_Id:Session_User_Id,
		};
		//console.log(requestInfo);
		var data = JSON.stringify(requestInfo);				
			var self = this;
			var config = {
			  method: 'post',
			  url: apiURL+'ManageUsers/DeleteUser',
			  headers: { 
				'Content-Type': 'application/json'
			  },
			  data : data
		};
		this.isLoading = true;
		axios(config)
		.then((result) => {
			this.isLoading = false;			
			if(result.data.status_code==200){
				//var obj=result.data.response;
				//console.log(obj[0]);
				alert(result.data.message);
				location.reload();
				//$('#reponse_error').html(result.data.message);
			}else{				
				$('#reponse_error').html(result.data.message);
			}
		  
		})
		.catch((error) => {
			this.isLoading = false;
			var errorObject=JSON.stringify(error.response.data.errors);			
			console.log(errorObject);		   
		});
	}
  }
}
</script>
